import React, { FC, useContext, useEffect, useRef, useState } from 'react';
import Dotloader from '../Dotloader/Dotloader';
import { createPortal } from 'react-dom';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import Styles from './StaticLineTable.module.scss';
import RichText from '../richtext';
import StaticProductEntitlement from './StaticProductEntitlement';
import StaticBenefit from './StaticBenefit';
import DynamicPriceSection from './DynamicPriceSection';
import CheckoutButton from './CheckoutButton';
import StaticProductDetails from './StaticProductDetails';
import { StaticProductSchema } from './StaticProductDatatypes';
import {
  AssetPathPropConfig,
  LineTableBasicPropConfig
} from '../../services/LineTableBasicPropConfig';
import Cookies from 'js-cookie';
import { LoginBasicPropConfig } from '../../services/LoginBasicPropConfig';
import LoginModalV2 from '../login/LoginModalV2';
import {
  checkGiftOrCashback,
  combineWithSmartPhone,
  combineWithVasOptions,
  fetchPrice,
  fetchServiceOptions,
  findHeight,
  isTimerActive,
  getTimeUntilNextTimerEvent,
  staticCreateCart
} from './Product.utils';
import GiftConfigV2 from '../ProductDetailsV3/GiftConfigV2';
import ChooseGiftV2 from '../ProductDetailsV3/ChooseGiftV2';
import { replacePlaceholder, viewport, getUtcTimestamp } from '../../utils/utils';
import StaticProductCashback from './StaticProductCashback';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';
import {
  CTABUTTONCLICK,
  DOWNLOADPRODUCT,
  EXISTINGCUSTOMER,
  GAEVENT,
  LINETABLE
} from '../../Analytics/AnalyticsConstants';
import TVChannelModal from './TVChannelModal';
import LinecheckModal from '../LineCheckV3/LinecheckModal';
import BenefitsValidateWrapper from '../BenefitWrapper/BenefitsValidateWrapper';
import PreToPostSubsPopup from '../PretoPost/PreToPostSubsPopup';
import GenericModal from '../LineCheckV3/GenericModal';
import {
  fetchSubscriptionData,
  trackPegaEvents,
  validateP2P
} from '../../services/LineTableService';
import ExsistingSubscriptionModal from './ExsistingSubscriptionModal';
import { getEcomCartInfo } from '../../models/Analytics/items';
import CoverageCheckModal from '../NewLineCheck/CoverageCheckModal';

import { API_BASE_BASEPOINT } from '../../services/api-constants';
import { AppContext } from './StaticLineTableStore/StaticLineTableProvider';
import OttServiceOptionsSmallPopup from './OttServiceOptions/OttServiceOptionsSmallPopup';
import StaticExclusiveBenefit from './StaticExclusiveBenefit';
// US_312953
import UserLoggedPricesToggle from '../UserLoggedPricesToggle/UserLoggedPricesToggle';
import FalconButtonV2 from '../FalconButtonV2/FalconButtonV2';
import { ONE_ECOMMERCE_INTERNET_SUMMARY } from '../../utils/constants';
import StaticLineTabelTimer from './StaticLineTabelTimer/StaticLineTabelTimer';
import { useProductCardBadge } from './ProductCardBadgeProvider';
import GenericPopup from '../GenericPopup/GenericPopup';

const StaticProduct: FC<StaticProductSchema> = ({
  content,
  offeringData,
  uniqueId,
  storyContent,
  metadata,
  tabIndex,
  cardsLength,
  indexKey,
  constants,
  mainContent,
  address,
  eligibleBundle,
  linecheckSuccessCallBack,
  selectedOption,
  fetchOfferData,
  basicConfigUrl,
  selectedExistingOption,
  setLoginSuccess,
  enableP2P,
  lineCheckCallBack,
  loginSuccess,
  setToggleState,
  toggleState,
  noTabs,
  deviceFlow,
  deviceFlowCallBack,
  selectedRP,
  continueCart,
  lineCheckOnClear,
  pegaIntegration,
  isProdEnv,
  deviceUltimateBundle,
  //US_31295
  toggleContent,
  pricesToggleState,
  isShogunFlow,
  shogunToken
}) => {
  const BadgeContainer = useProductCardBadge();
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showProductDetail, setShowProductDetail] = useState(false);
  const [showGiftOrCashback, setShowGiftOrCashback] = useState({
    showGift: false,
    cashbackAvailable: false
  });
  const [modalClick, updateModalClick] = useState(true);
  const [combine, setCombine] = useState(false);
  const [giftItem, setGiftItem] = useState<any>([]);
  const [showLogin, setShowLogin] = useState<boolean>(false);
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [showLinecheck, setShowLinecheck] = useState<boolean>(false);
  const [showP2P, setShowP2P] = useState<boolean>(false);
  const [showBenefit, setShowBenefit] = useState<boolean>(false);
  const [subscriptionFailure, setSubscriptionFailure] = useState(false);
  const endpoint = `${basicConfigUrl}inf/customer-management/subscriptions`;
  const validateEndpoint = `${basicConfigUrl}inf/resource-management/msisdns/pretopost/validation`;
  const [userSubscriptionData, setUserSubscriptionData] = useState<any>([]);
  const [afterLogin, setAfterLogin] = useState<boolean>(false);
  const [popUPClick, setModalClick] = useState<boolean>(false);
  const [p2pModal, setP2pModal] = useState<boolean>(false);
  const [tvOptions, setTvOptions] = useState<any[] | undefined>([]);
  const [displayTvOptionsPopUp, setDisplayTvOptionsPopUp] = useState<boolean>(false);
  const [alreadyShowedTvOptionsPopUp, setAlreadyShowedTvOptionsPopUp] = useState<boolean>(false);
  const [tvOptionsPopUpChanged, setTvOptionsPopUpChanged] = useState<boolean>(false);
  const [tvOptionsPopUpAddToCart, setTvOptionsPopUpAddToCart] = useState<boolean>(false);
  const [responseList, setResponseList] = useState([]);
  const [timerSpaceHeight, setTimerSpaceHeight] = useState(0);
  const [showReplaceCartModal, setShowReplaceCartModal] = useState<boolean>(false);
  const pendingCartActionRef = useRef<(() => void) | null>(null);
  const [replacePopupContent, setReplacePopupContent] = useState<any>(null);
  const shouldDeleteCartCookieRef = useRef<boolean>(false);
  const timerContainerRef = useRef<HTMLDivElement | null>(null);
  const pegaEndpoint = `${basicConfigUrl}inf/${API_BASE_BASEPOINT.CUSTOMER}`;

  /*the portal position for the the dotloader*/
  const portalPosition: any =
    typeof window !== undefined && document.getElementById('static-linetable');
  const isSkeletonLoading = Object.keys(content)?.length === 0;
  const productData = content?.products?.[0]?.reference?.content?.product?.[0];
  const promotionData = content?.promotion?.[0]?.reference?.content?.promoDescription?.[0];
  const timerContent = content?.timer?.[0];
  const isCounterEnabled = timerContent?.enableCounter;
  const [timerIsActive, setTimerIsActive] = useState(
    isCounterEnabled && timerContent?.startTime && timerContent?.endTime
      ? isTimerActive(timerContent.startTime, timerContent.endTime)
      : false
  );
  const showHighlightText = Boolean(
    content?.highlightText &&
    pricesToggleState !== true &&
    !timerIsActive &&
    !(BadgeContainer && content?.badgesContainer)
  );
  const showPromoContainer = Boolean(
    promotionData?.displayText &&
    !content?.notShowPromotionLabel &&
    pricesToggleState !== true &&
    !timerIsActive
  );

  const showBadges = Boolean(
    BadgeContainer &&
    content?.badgesContainer &&
    pricesToggleState !== true &&
    !timerIsActive &&
    !showPromoContainer
  );

  const id = productData?.productId;
  const cartEndPoint = LineTableBasicPropConfig?.getInstance()?.getCartUrl();
  const assetPath = AssetPathPropConfig?.getInstance()?.getAssetPath();
  const isMobileFlow = storyContent?.pageType === 'MOBILE';
  const viewPortType = viewport();
  const context = useContext(AppContext);
  let isAvailable: boolean | undefined = undefined;
  isAvailable = address && eligibleBundle?.eligibleBundle?.includes(id);
  const enableTVStreamingOptionsPopUp = content?.enableTVStreamingOptionsPopUp;
  const enableTVStreamingOptionsStepper = content?.enableTVStreamingOptionsStepper;
  const disableDiscountedPriceToggle = content?.disableDiscountedPriceToggle;
  const skipAccessoriesPage = content?.skipAccessoriesPage;

  LoginBasicPropConfig.create({ baseURL: basicConfigUrl ?? '' });

  //sunrise auth data
  let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
  AuthData = AuthData && JSON.parse(AuthData);
  //offer data wrt to tab
  const uniqueProductData: any = (offeringData?.[uniqueId] || []).filter(
    (product: any) => product?.id === id
  );

  const setTvOptionsData = (options: any) => {
    setTvOptions(options);
  };

  const handleP2PClick = () => {
    setShowLogin(true);
    setShowP2P(!showP2P);
    setModalClick(!popUPClick);
  };

  //creacart function or login pop up
  const createCart = () => {
    setShowProductDetail(false);
    if (enableP2P && AuthData == undefined) {
      setShowP2P(!showP2P);
      setModalClick(!popUPClick);
    } else if (enableP2P && AuthData?.siteId) {
      fetchPrepaidData();
    } else if (selectedOption === EXISTINGCUSTOMER && selectedExistingOption?.length > 0) {
      setShowBenefit(true);
    } else {
      //US_31295
      const setLoginCookie =
        (mainContent?.enableExistingCustomer && AuthData == undefined) ||
        (!AuthData && pricesToggleState === true && toggleContent?.enableLoggedInPrice)
          ? true
          : false;
      setLoginCookie ? setShowLogin(true) : createCartCall();
    }
    if (pegaIntegration) {
      const prospectId = localStorage.getItem('prospectId');
      const url = window?.location?.pathname?.split('/') ?? [];
      const pathname = url[url.length - 1];
      const payload = {
        eventTimestamp: getUtcTimestamp(),
        eventType: 'PageView',
        pageType: 'CartCreated',
        pageLocation: pathname,
        // deviceType: viewPortType,#TODO - fix this values, isn't working for tablet
        targetProduct: id
      };
      prospectId && trackPegaEvents(pegaEndpoint, payload, prospectId);
    }
  };

  //setting the selected gift from choose gift section
  const selectedGiftItem = (item: any) => {
    const itemValue = giftItem.findIndex((gift: any) => item?.giftGroupId === gift?.giftGroupId);
    const temp = giftItem;
    if (itemValue === -1) temp.push(item);
    else temp[itemValue] = item;
    setGiftItem([...temp]);
  };

  // Helper method to get border styles
  const getBorderStyles = () => {
    const borderConfig = showPromoContainer ? promotionData : content;
    const showBorder = borderConfig?.showBorder;
    const borderGradient = borderConfig?.borderGradient;
    const borderColor = borderConfig?.borderColor;

    return {
      borderColor: showBorder && !borderGradient ? borderColor || '' : 'transparent',
      borderWidth: showBorder ? '4px' : '0px',
      borderStyle: showBorder ? 'solid' : 'none',
      borderRadius: showBorder ? '8px' : '',
      background: showBorder && borderGradient
        ? `linear-gradient(white, white) padding-box, ${borderGradient} border-box`
        : undefined,
    };
  };

  //queryParam for MySunrise P2P flow
  const params = new URLSearchParams(window?.location?.search);
  const queryParams = params?.get('selectedMsisdn');
  const validateNumberFcn = (value: any) => {
    // once all the prepaid numbers are validated
    if (value?.length === 1) {
      combine
        ? combineWithSmartPhone(
            showPrice,
            storyContent,
            uniqueProductData,
            value?.[0],
            content,
            pegaIntegration
          )
        : createCartCall(value?.[0]?.msisdn);
      setSubscriptionFailure(false);
    } else if (value?.length > 1) {
      setUserSubscriptionData(value);
      setP2pModal(!p2pModal);
      setSubscriptionFailure(false);
    } else {
      setModalClick(!popUPClick);
      setSubscriptionFailure(true);
      updateModalClick(true);
      setShowLoader(false);
    }
  };
  const validateFcn = async (value: any, validPrepaidNumbers: any) => {
    await validateP2P(value?.msisdn, validateEndpoint)
      .then((res) => {
        if (res) {
          validPrepaidNumbers.push(value);
        }
      })
      .catch((e: any) => {
        // eslint-disable-next-line no-console
        console.log('error', e);
      });
  };
  //prepaid  subscription api and validating those for conversion
  const fetchPrepaidData = () => {
    setShowLoader(true);
    try {
      fetchSubscriptionData('PREPAID', endpoint)
        ?.then(async (resp: any) => {
          if (resp?.subscriptionData == 204) {
            setModalClick(!popUPClick);
            setSubscriptionFailure(true);
            updateModalClick(true);
            setShowLoader(false);
          } else {
            const responseData = resp?.subscriptionData;
            const queryData = responseData.find((entry: any) => entry.msisdn === queryParams);
            if (responseData) {
              const validPrepaidNumbers: any = [];
              if (queryParams) {
                await validateFcn(queryData, validPrepaidNumbers);
                validateNumberFcn(validPrepaidNumbers);
              } else {
                await Promise.all(
                  responseData?.map(async (data: any) => {
                    await validateFcn(data, validPrepaidNumbers);
                  })
                ).then((succ) => {
                  validateNumberFcn(validPrepaidNumbers);
                });
              }
            }
          }
        })
        .catch((error: any) => {
          // eslint-disable-next-line no-console
          console.log('error--->', error);
          setShowLoader(false);
        });
    } catch (err: any) {
      // eslint-disable-next-line no-console
      console.log('error--->', err);
      setShowLoader(false);
    }
    setAfterLogin(true);
  };

  // on login success
  const onLoginSuccess = () => {
    setShowLogin(false);
    setLoginSuccess();
    sessionStorage.removeItem('vasPopUp');
    setAlreadyShowedTvOptionsPopUp(false);
    if (enableP2P) {
      fetchPrepaidData();
    } else {
      createCartCall();
    }
  };

  // to close the pop up of P2P
  const handleClick = () => {
    setModalClick(!modalClick);
    setShowP2P(false);
  };

  // to close the pop up of P2P for success prepiad
  const handlePrepaidClick = () => {
    setShowLoader(false);
    setP2pModal(!p2pModal);
  };

  const closeTVOptionsModal = (event?: any) => {
    setDisplayTvOptionsPopUp(false);

    if (event) {
      trackNewDatalayerEvent(GAEVENT, CTABUTTONCLICK, {
        headline: 'VAS POPUP CLOSE'
      });
    }
  };

  //once linecheck success set linecheck pop up false and proceed to checkout section
  const linecheckSuccess = () => {
    let bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
    eligibleBundle = bundle && JSON?.parse(bundle);
    address = typeof window !== 'undefined' && Cookies.get('chAddressJson');
    typeof linecheckSuccessCallBack == 'function' && linecheckSuccessCallBack();
  };

  //once linecheck success set linecheck pop up false and proceed to checkout section
  const linecheckSuccessAndCart = () => {
    let bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
    eligibleBundle = bundle && JSON?.parse(bundle);
    address = typeof window !== 'undefined' && Cookies.get('chAddressJson');
    setShowLinecheck(!showLinecheck);
    typeof linecheckSuccessCallBack == 'function' && linecheckSuccessCallBack();
    createCartCall();
  };

  //service Option set for TV

  const serviceOption = fetchServiceOptions(productData?.bloks, isMobileFlow);

  const radioValue = serviceOption?.[0]?.tvProductId;

  const createCartCallAction = (msisdn?: string) => {
    const discountRef = pegaIntegration && uniqueProductData?.[0]?.promotionInfo?.[0]?.id;
    const discountVersion = pegaIntegration && uniqueProductData?.[0]?.promotionInfo?.[0]?.version;

    // Shogun / rewards (loyalty) flow: attach the pointsBurnt note so the
    // backend can settle the loyalty burn during cart creation. The value
    // comes from the offer response under `rewards.points`.
    const rewardsInfo = isShogunFlow
      ? { pointsBurnt: uniqueProductData?.[0]?.rewards?.points, rewardOfferId: uniqueProductData?.[0]?.rewards?.offerId, gloxTokenId: shogunToken }
      : undefined;

    // US 317400- vas options pop tracking
    if (uniqueProductData && uniqueProductData[0]) {
      uniqueProductData[0].fromPopup = tvOptionsPopUpAddToCart;
    }
    updateVasPopUp('false');
    sessionStorage.removeItem('vasPopUp');
    setAlreadyShowedTvOptionsPopUp(false);

    staticCreateCart(
      setShowLoader,
      cartEndPoint,
      giftItem,
      uniqueProductData,
      mainContent,
      showPrice,
      isMobileFlow,
      radioValue,
      eligibleBundle,
      address,
      setShowLinecheck,
      showLinecheck,
      lineCheckCallBack,
      enableP2P,
      queryParams ?? msisdn,
      content,
      tvOptions,
      discountRef,
      discountVersion,
      rewardsInfo
    );
  };
  //cart creation
  const createCartCall = (msisdn?: string) => {
    setTvOptionsPopUpAddToCart(false);
    setShowProductDetail(false);
    let AuthData: any = typeof window !== undefined && Cookies.get('sunriseAuth');
    const AuthDataNew = AuthData && JSON.parse(AuthData);
    const setLoginCookie =
      mainContent?.enableExistingCustomer && AuthDataNew == undefined ? true : false;
    sessionStorage.removeItem(ONE_ECOMMERCE_INTERNET_SUMMARY);
    if (mainContent?.linecheckData?.length > 0 && !isMobileFlow && !isAvailable) {
      // setShowLinecheck(true);
      const lineCheckElement = document.getElementById('linecheck');
      if (lineCheckElement) {
        lineCheckCallBack();
      }
      return;
    } else if (
      isAvailable &&
      !isMobileFlow &&
      mainContent?.loginData?.length > 0 &&
      setLoginCookie
    ) {
      setShowLogin(true);
    } else if (enableTVStreamingOptionsStepper && uniqueProductData[0]?.isBundle) {
      let recommendAccessory = false;

      if (!skipAccessoriesPage) {
        /**Check if bundle or Internet and add it to cart request*/
        if (uniqueProductData[0]?.isBundle) {
          uniqueProductData[0]?.bundledOffers?.map((item: any) => {
            if (
              item?.productType?.toLowerCase() === 'internet' ||
              item?.productType?.toLowerCase() == 'tv'
            ) {
              if (item?.recommendAccessory) {
                recommendAccessory = item?.recommendAccessory;
              }
            }
            // setting to false incase of Mobile product Type as it is currently out of scope
            if (item?.productType?.toLowerCase() === 'mobile') {
              recommendAccessory = false;
              return;
            }
          });
        } else {
          /**Add standlone product such as internet to cart request*/
          if (uniqueProductData?.[0]?.recommendAccessory) {
            recommendAccessory = uniqueProductData?.[0]?.recommendAccessory;
          }
        }
      }

      combineWithVasOptions(
        showPrice,
        uniqueProductData,
        content,
        pegaIntegration,
        productData?.productName,
        recommendAccessory
      );
      createCartCallAction(msisdn);
    } else if (
      enableTVStreamingOptionsPopUp &&
      uniqueProductData[0]?.isBundle &&
      !alreadyShowedTvOptionsPopUp
    ) {
      setDisplayTvOptionsPopUp(true);
      setAlreadyShowedTvOptionsPopUp(true);
      updateVasPopUp('true');

      window.addEventListener('beforeunload', function (event) {
        updateVasPopUp('false');
        sessionStorage.removeItem('vasPopUp');
        setAlreadyShowedTvOptionsPopUp(false);
      });
    } else {
      //for mobile p2p
      if (enableP2P) {
        setShowLoader(true);
      }
      createCartCallAction(msisdn);
    }
  };

  //cart creation callback For device first flow
  const deviceFirstFlowCreateCartCallback = (msisdn?: string) => {
    setShowProductDetail(false);
    const msisdnn = queryParams ?? msisdn;
    const deviceFirstFlowCartObj = {
      setShowLoader,
      cartEndPoint,
      giftItem,
      uniqueProductData,
      mainContent,
      showPrice,
      isMobileFlow,
      eligibleBundle,
      address,
      setShowLinecheck,
      showLinecheck,
      lineCheckCallBack,
      enableP2P,
      msisdnn,
      content,
      selectedRP,
      continueCart
    };
    deviceFlowCallBack(deviceFirstFlowCartObj);
  };

  // Guards a cart-creation action: if a persistent cart already exists
  // (one-commerce-cartId cookie), show the replace-cart popup and defer the
  // action until the user confirms via the primary button.
  const withReplaceCartCheck =
    (action: (callFunctionArg?: string) => void, popupContent?: any) =>
    (callFunctionArg?: string) => {
      const existingCartId =
        typeof window !== undefined && Cookies.get('one-commerce-cartId');
      if (mainContent?.enableReplacePopup && existingCartId) {
        pendingCartActionRef.current = () => action(callFunctionArg);
        shouldDeleteCartCookieRef.current = Boolean(popupContent);
        setReplacePopupContent(popupContent ?? mainContent?.generalReplacePopup?.[0]);
        setShowReplaceCartModal(true);
      } else {
        action(callFunctionArg);
      }
    };

  // after 1 prepaid numbers selection from existingp2pmodal
  const onSelectSubscriptionPreToPost = (value: any) => {
    setP2pModal(!p2pModal);
    combine
      ? combineWithSmartPhone(
          showPrice,
          storyContent,
          uniqueProductData,
          value,
          content,
          pegaIntegration
        )
      : createCartCall(value?.msisdn);
  };
  //show price calculation
  const showPrice = fetchPrice(
    uniqueProductData,
    isMobileFlow,
    mainContent?.pageType,
    false,
    tvOptions,
    pegaIntegration
  );

  //card height calculation and gift & cashback check on change of offer data
  //to calculate the height when the tvOptions is added and removed
  useEffect(() => {
    setTimeout(() => {
      findHeight(tabIndex, cardsLength);
    }, 100);
    const result = checkGiftOrCashback(
      isMobileFlow
        ? uniqueProductData
        : (uniqueProductData?.[0]?.bundledOffers ?? uniqueProductData)
    );
    setShowGiftOrCashback({ ...result });
  }, [
    offeringData,
    toggleState,
    tvOptions,
    timerSpaceHeight,
    (toggleState?.TV || toggleState?.gigaSpeed || toggleState?.Netflix) &&
      Array.isArray(uniqueProductData) &&
      uniqueProductData?.[0]?.bundledOffers?.length === 3
  ]);

  //product details pop up
  const showDetailsModal = () => {
    setShowProductDetail(!showProductDetail);
    //Analytics Product Details tracking
    let offerData = uniqueProductData;
    trackNewDatalayerEvent(GAEVENT, DOWNLOADPRODUCT, getEcomCartInfo(offerData, '', LINETABLE));
    const prospectId = localStorage.getItem('prospectId');
    const url = window?.location?.pathname?.split('/') ?? [];
    const pathname = url[url.length - 1];
    const payload = {
      eventTimestamp: getUtcTimestamp(),
      eventType: 'PageView',
      pageType: 'ProductDetails',
      pageLocation: pathname,
      // deviceType: viewPortType, #TODO - fix this values, isn't working for tablet
      targetProduct: id
    };
    prospectId && trackPegaEvents(pegaEndpoint, payload, prospectId);
  };

  //TV service option
  const showModalPopup = () => {
    if (serviceOption?.length > 0 || enableTVStreamingOptionsPopUp) {
      setShowOptions(true);
    }
  };
  const updatedContent = mainContent?.productContainer?.[0];

  // set the combine to true for p2p
  const combineP2P = () => {
    setCombine(true);
  };

  // to trigger on click of combinewith smartphone
  useEffect(() => {
    if (combine) {
      if (enableP2P && AuthData == undefined) {
        setShowP2P(!showP2P);
        setModalClick(!popUPClick);
      } else if (enableP2P && AuthData?.siteId) {
        fetchPrepaidData();
      }
    }
  }, [combine]);

  useEffect(() => {
    if (context) {
      const { store } = context;
      if (store?.ottOptionsApi?.length > 0 && responseList?.length === 0) {
        setResponseList(store?.ottOptionsApi);
      }
    }
  }, [context]);

  useEffect(() => {
    if (!isCounterEnabled || !timerContent?.startTime || !timerContent?.endTime) {
      setTimerIsActive(false);
      return;
    }

    setTimerIsActive(isTimerActive(timerContent.startTime, timerContent.endTime));

    const delay = getTimeUntilNextTimerEvent(timerContent.startTime, timerContent.endTime);
    if (delay <= 0) return;

    const timeout = setTimeout(() => {
      setTimerIsActive(isTimerActive(timerContent.startTime, timerContent.endTime));
    }, delay);

    return () => clearTimeout(timeout);
  }, [isCounterEnabled, timerContent?.startTime, timerContent?.endTime]);

  useEffect(() => {
    const timerElement = timerContainerRef.current;
    if (!timerElement || !content?.timer?.length || !isCounterEnabled) {
      setTimerSpaceHeight(0);
      return;
    }

    const updateTimerSpaceHeight = () => {
      setTimerSpaceHeight(timerElement.clientHeight);
    };

    updateTimerSpaceHeight();

    if (typeof ResizeObserver === 'undefined') {
      return;
    }

    const resizeObserver = new ResizeObserver(updateTimerSpaceHeight);
    resizeObserver.observe(timerElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [content?.timer?.length, isCounterEnabled]);

  // to trigger on click tv option pop up closed
  useEffect(() => {
    if (tvOptionsPopUpChanged) {
      closeTVOptionsModal();
      setTvOptionsPopUpChanged(true);
      updateVasPopUp('false');
      sessionStorage.removeItem('vasPopUp');
      setAlreadyShowedTvOptionsPopUp(false);
      createCartCallAction();
    }
  }, [tvOptionsPopUpChanged]);

  //US 314008 - only show vas pop up for first time user clicked order now
  useEffect(() => {
    const checkVasPopUp = () => {
      const vasPopUp = sessionStorage.getItem('vasPopUp');

      setAlreadyShowedTvOptionsPopUp(vasPopUp === 'true');
    };

    checkVasPopUp();

    const handleStorageChange = (event: StorageEvent) => {
      if (event.storageArea === sessionStorage && event.key === 'vasPopUp') {
        checkVasPopUp();
      }
      // If vasPopUp is removed (deleted)
      if (
        event.storageArea === sessionStorage &&
        event.key === 'vasPopUp' &&
        event.newValue === null
      ) {
        setAlreadyShowedTvOptionsPopUp(false);
      }
    };

    const handleCustomEvent = () => {
      checkVasPopUp();
    };
    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('vasPopUpChange', handleCustomEvent);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('vasPopUpChange', handleCustomEvent);
    };
    
  }, []);

  const updateVasPopUp = (value: string) => {
    sessionStorage.setItem('vasPopUp', value);
    const event = new Event('vasPopUpChange');
    window.dispatchEvent(event);
  };

  return (
    <div>
      {showLoader &&
        portalPosition &&
        createPortal(<Dotloader keyParams='loading' />, portalPosition)}
      {isSkeletonLoading && (
        <div className='w-75 pb-2'>
          <SkeletonLoader />
        </div>
      )}
      {!isSkeletonLoading && eligibleBundle && content && address && !isMobileFlow && (
        <div className={Styles.selected}>
          <span style={{ paddingBottom: '10px' }}>
            {!isAvailable ? (
              <span className={Styles.inactiveicon}>
                <img
                  src={`${assetPath}/icons/cross_disabled.svg`}
                  alt=''
                  width={24}
                  height={24}
                  className={Styles.inactiveicon}
                />
                <span>{constants?.notSubscriptionTxt}</span>
              </span>
            ) : (
              <span className={Styles.activeicon}>
                <img
                  src={`${assetPath}/icons/lineCheck-success.svg`}
                  alt=''
                  width={24}
                  height={24}
                  className={Styles.activeicon}
                />
                <span>{constants?.subscriptionAvalTxt}</span>
              </span>
            )}
          </span>
        </div>
      )}

      <div
        className={`${
          !isMobileFlow &&
          isAvailable === false &&
          mainContent?.linecheckData?.length > 0 &&
          mainContent?.linecheckData?.[0]?.reference?.default_full_slug !== 'global/coverage-check'
            ? Styles.overlay
            : ''
        }
        ${deviceUltimateBundle && !uniqueProductData?.[0]?.eligibility?.fpb ? Styles.disabled : ''}
        `}
        style={{ flexDirection: 'column' }}
      >
        <div className={Styles.bundleproductcard}>
          <div
            id={`timer-section${tabIndex}${indexKey}`}
            data-timer-active={timerSpaceHeight > 0 ? 'true' : 'false'}
          >
            {content?.timer?.length && isCounterEnabled ? (
              <div style={{ height: `${timerSpaceHeight}px`, transition: 'height 0.3s ease' }} />
            ) : null}
          </div>
          <div className={`${Styles.productcontainer}`} style={getBorderStyles()}>
            {showBadges && BadgeContainer && <BadgeContainer badges={content.badgesContainer} />}
            {showHighlightText && (
              <div className={`${Styles.highlightText}`}>{content?.highlightText}</div>
            )}

            {showPromoContainer &&
              (promotionData?.badgeContainer && BadgeContainer ? (
                <BadgeContainer badges={promotionData?.badgeContainer} />
              ) : (
                <div
                  className={`${Styles.promocontainer}`}
                  style={{
                    background: promotionData?.bestSellerColor
                  }}
                >
                  {promotionData?.displayText}
                </div>
              ))}
            <div ref={timerContainerRef} className={Styles.timerContainer}>
              {content?.timer?.length && isCounterEnabled ? (
                <StaticLineTabelTimer
                  content={content?.timer?.[0]}
                  hasHighlightText={showBadges || showPromoContainer}
                  onTimerChange={(active) => {
                    setTimerIsActive(active);
                  }}
                />
              ) : null}
            </div>
            <div
              className={`${Styles.detailsection} ${Styles.imageFullWidthSection}`}
              id={`detailsectionv3${tabIndex}${indexKey}`}
            >
              <div className={`${Styles.headersection}`}>
                <div className={`${Styles.titlesection}`}>
                  <div className={`${Styles.productheader}`} id={`titleV3${tabIndex}${indexKey}`}>
                    {productData?.productName}
                  </div>
                  <div>
                    {productData?.icon?.filename && (
                      <img
                        className={`${Styles.imagecontainer}`}
                        src={productData?.icon?.filename}
                        height={15}
                        width={20}
                        alt='productIcon'
                      />
                    )}
                  </div>
                </div>
                <div
                  className={`${Styles.productdescription}`}
                  id={`descriptionV3${tabIndex}${indexKey}`}
                >
                  <RichText content={productData?.description} />
                </div>
                {/* Image(map) */}
                <div className={`${Styles.images}`}>
                  {productData?.img?.filename && (
                    <img
                      className={`${Styles.imagespace} ${
                        content?.highlightText && Styles.borderimage
                      }`}
                      alt='cardimg'
                      src={`${productData?.img?.filename}/m/`}
                    />
                  )}
                </div>
              </div>
              {/* product entitlement section */}
              <div
                className={`${Styles.productconfig}`}
                id={`product-configv3${tabIndex}${indexKey}`}
              >
                {isSkeletonLoading ? (
                  <>
                    <div className={Styles.space}></div>
                    <SkeletonLoader stylename={Styles.skeletontittle} count={1} />
                    <SkeletonLoader stylename={Styles.skeletonline} count={5} />
                    <div className={Styles.space}></div>
                    <SkeletonLoader stylename={Styles.skeletontittle} count={1} />
                    <SkeletonLoader stylename={Styles.skeletonline} count={5} />
                  </>
                ) : (
                  <div>
                    {productData?.bloks &&
                      productData?.bloks?.map((entitle: any, index: number) => {
                        return (
                          <StaticProductEntitlement
                            content={entitle}
                            indexKey={index}
                            constants={constants}
                            key={index}
                            showModalPopup={showModalPopup}
                            setToggleState={setToggleState}
                            toggleState={toggleState}
                            noTabs={noTabs}
                            mainContent={mainContent}
                            enableTVStreamingOptions={content?.enableTVStreamingOptions}
                            metadata={metadata}
                            setTvOptionsData={setTvOptionsData}
                          />
                        );
                      })}
                  </div>
                )}
              </div>
            </div>
            {/* benefits section */}
            <div
              className={`${Styles.detailsection}`}
              id={`benefits-price-section${tabIndex}${indexKey}`}
            >
              <div id={`exclusive-benefits-section${tabIndex}${indexKey}`}>
                {productData?.extraBenefits?.length > 0 && (
                  <StaticExclusiveBenefit content={productData?.extraBenefits?.[0]} />
                )}
              </div>
              <div
                className={`${Styles.benefitssection}`}
                id={`benefits-section${tabIndex}${indexKey}`}
              >
                {productData?.benefits?.length > 0 && (
                  <StaticBenefit
                    content={productData?.benefits}
                    benefitData={showPrice}
                    constants={constants}
                    //US_31295
                    pricesToggleState={pricesToggleState}
                    togglePriceLabel={toggleContent?.togglePriceLabel}
                  />
                )}
              </div>
              <br />

              {/* gift or cashback section */}
              <div className={`${Styles.giftsection}`} id={`gift-section${tabIndex}${indexKey}`}>
                {showGiftOrCashback?.showGift &&
                  promotionData?.singleGift?.map((item: any, index: number) => {
                    return <GiftConfigV2 content={item} key={index} />;
                  })}
                {showGiftOrCashback?.showGift &&
                  promotionData?.giftConfig?.map((item: any, index: number) => {
                    return (
                      <ChooseGiftV2
                        content={item}
                        key={index}
                        selectedGiftItem={selectedGiftItem}
                        parentPoType={isMobileFlow ? 'MOBILE' : 'HOME'}
                      />
                    );
                  })}
                <div
                  className={`${Styles.giftsection}`}
                  id={`cashback-section${tabIndex}${indexKey}`}
                >
                  <StaticProductCashback
                    uniqueProductData={uniqueProductData}
                    mainContent={mainContent}
                  />
                </div>
              </div>
              {/* price section */}
              <div className={`${Styles.ordersection}`} id={`order-section${tabIndex}${indexKey}`}>
                {showPrice?.base === '' ? (
                  <div>
                    <SkeletonLoader stylename={Styles.skeletontittle} />
                  </div>
                ) : (
                  <div id={`price-section${tabIndex}${indexKey}`}>
                    <DynamicPriceSection
                      priceCollection={showPrice}
                      constants={constants}
                      promoText={productData?.promoText}
                      deviceFlow={deviceFlow}
                      content={content}
                      offeringData={offeringData}
                      uniqueId={uniqueId}
                    />
                  </div>
                )}

                {/* US_312953 */}
                {!isShogunFlow && (
                  <div
                    className={`${Styles.discountedpricetoggleSection}`}
                    id={`discountedpricetoggle-section${tabIndex}${indexKey}`}
                  >
                    {!disableDiscountedPriceToggle && toggleContent?.togglePosition === 'INLINE' ? (
                      <UserLoggedPricesToggle
                        content={productData}
                        index={indexKey}
                        lineTable={true}
                        toggleContent={toggleContent}
                      />
                    ) : null}
                  </div>
                )}
                {/*END US_312953 */}

                {/* Longterm text  */}
                {enableP2P && constants?.P2PDiscountLabel && (
                  <div className={Styles.longterm}>{constants?.P2PDiscountLabel}</div>
                )}
                {/* proceed to checkout section */}
                {isSkeletonLoading ? (
                  <>
                    <SkeletonLoader stylename={Styles.skeletontittle} count={1} />
                    <SkeletonLoader stylename={Styles.skeletonline} count={2} />
                  </>
                ) : (
                  <div className={`${storyContent?.swapButton && Styles.swapButton}`}>
                    <div style={{ padding: '16px 0 0 0' }}>
                      <CheckoutButton
                        isMobileFlow={isMobileFlow}
                        createCartCall={
                          deviceFlow?.isDeviceFlow
                            ? withReplaceCartCheck(deviceFirstFlowCreateCartCallback)
                            : isMobileFlow
                              ? withReplaceCartCheck(createCart)
                              : withReplaceCartCheck(createCartCall)
                        }
                        constants={constants}
                        storyContent={storyContent}
                        showPrice={showPrice}
                        isAvailable={isAvailable}
                        address={address}
                        uniqueProductBenefits={uniqueProductData?.[0]}
                        alwaysActive={
                          !isAvailable &&
                          mainContent?.linecheckData?.length > 0 &&
                          mainContent?.linecheckData?.[0]?.reference?.default_full_slug ===
                            'global/coverage-check'
                        }
                        flexUpgradeFreePopup={mainContent?.flexUpgradeFreePopup?.reference?.content}
                        content={content}
                        deviceUltimateBundle={deviceUltimateBundle}
                        forceDisabled={Boolean(uniqueProductData?.[0]?.rewards?.notEligibleReason)}
                        notEligibileReason={uniqueProductData?.[0]?.rewards?.notEligibleReason}
                      />
                    </div>
                    {/* combined with smartphone section */}
                    {!isShogunFlow &&
                      storyContent?.addSmartPhone?.length > 0 &&
                      !deviceFlow?.isDeviceFlow && (
                        <div style={{ textAlign: 'center' }}>
                          {storyContent?.swapButton
                            ? storyContent?.ctaLabel && (
                                <div style={{ padding: '16px 0' }}>
                                  <button
                                    className={`primarybutton`}
                                    onClick={() =>
                                      withReplaceCartCheck(
                                        () =>
                                          combineWithSmartPhone(
                                            showPrice,
                                            storyContent,
                                            uniqueProductData,
                                            '',
                                            content,
                                            pegaIntegration
                                          ),
                                        mainContent?.replacePopupWithSmartphone?.[0]
                                      )()
                                    }
                                  >
                                    <span className={Styles.buttontext}>
                                      {storyContent?.ctaLabel}
                                    </span>
                                  </button>
                                </div>
                              )
                            : !content?.redirectOnly && (
                                <div style={{ padding: '12px 0 0 0' }}>
                                  <FalconButtonV2
                                    content={{
                                      buttonType: 'Secondary-V1',
                                      buttonLabel: content?.ultimateBundlePromotion
                                        ? constants?.ultimateBundleLbl
                                        : storyContent?.addSmartPhone?.[0]?.buttonLabel,
                                      buttonIcon: storyContent?.addSmartPhone?.[0]?.buttonIcon,
                                      buttonAlignment: 'left'
                                    }}
                                    wafIdentifier={basicConfigUrl}
                                    style={{ width: '100%' }}
                                    onClick={() =>
                                      withReplaceCartCheck(
                                        () =>
                                          enableP2P
                                            ? combineP2P()
                                            : combineWithSmartPhone(
                                                showPrice,
                                                storyContent,
                                                uniqueProductData,
                                                '',
                                                content,
                                                pegaIntegration
                                              ),
                                        mainContent?.replacePopupWithSmartphone?.[0]
                                      )()
                                    }
                                  />
                                </div>
                              )}
                        </div>
                      )}
                    <div
                      className={Styles.productcontractduration}
                      id={`contract-section${tabIndex}${indexKey}`}
                      style={{
                        paddingTop:
                          storyContent?.addSmartPhone?.length > 0 &&
                          !deviceFlow?.isDeviceFlow &&
                          !storyContent?.swapButton &&
                          !content?.redirectOnly
                            ? '8px'
                            : undefined
                      }}
                    >
                      {showPrice?.contractDuration > '1'
                        ? replacePlaceholder(constants?.minContractDuration?.substring(1), [
                            showPrice?.contractDuration
                          ])
                        : constants?.noContractDuration}
                    </div>
                  </div>
                )}
                {/* product details section */}
                <div style={{ textAlign: 'center', padding: '4px' }}>
                  {productData?.productDetails?.length > 0 && (
                    <span className={Styles.productdetailslink} onClick={showDetailsModal}>
                      {constants?.productDetailsLink}
                    </span>
                  )}
                </div>
                {showProductDetail && (
                  <StaticProductDetails
                    content={productData?.productDetails}
                    showProductDetail={showProductDetail}
                    setShowProductDetail={setShowProductDetail}
                    constants={constants}
                    showPrice={showPrice}
                    isMobileFlow={isMobileFlow}
                    createCartCall={isMobileFlow ? createCart : createCartCall}
                    storyContent={storyContent}
                    isAvailable={isAvailable}
                    address={address}
                    flexUpgradeFreePopup={mainContent?.flexUpgradeFreePopup?.reference?.content}
                    notEligibileReason={uniqueProductData?.[0]?.rewards?.notEligibleReason}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deviceUltimateBundle && uniqueProductData && !uniqueProductData?.[0]?.eligibility?.fpb && (
        <div className={Styles.disabledInfo}>
          <RichText content={constants?.fpbNotCompatibleText} />
        </div>
      )}

      {showOptions &&
        (isSkeletonLoading ? (
          <SkeletonLoader />
        ) : (
          <TVChannelModal
            content={serviceOption?.[0]}
            setShowModal={setShowOptions}
            showModal={showOptions}
            constants={constants}
          />
        ))}

      {/* login pop up existing customer benefit without login on click of proceed to checkout */}
      {showLogin &&
        mainContent?.loginData?.length > 0 &&
        portalPosition &&
        createPortal(
          <LoginModalV2
            content={mainContent?.loginData?.[0]}
            closeLogin={() => {
              setShowLogin(false);
            }}
            metadata={metadata}
            onSuccess={onLoginSuccess}
            isProdEnv={isProdEnv}
          />,
          portalPosition
        )}

      {/* P2P flow first screen to select login */}
      {showP2P && enableP2P && !showLogin && popUPClick && (
        <GenericModal
          modalState={modalClick}
          handler={handleClick}
          showFooter={false}
          width={'628px'}
          height='280px'
          backgroundColor='#f7f6f5'
          noCloseButton={false}
          backDrop={true}
          bodyPadding='16px'
        >
          <PreToPostSubsPopup
            onClose={handleP2PClick}
            content={mainContent?.productContainer?.[0]?.p2pBloks?.[0]}
            prepaid={false}
          />
        </GenericModal>
      )}

      {/* P2P flow error screen if the customer is not prepaid customer */}
      {enableP2P && afterLogin && subscriptionFailure && popUPClick && (
        <GenericModal
          modalState={modalClick}
          handler={handleClick}
          showFooter={false}
          width={'628px'}
          height='280px'
          backgroundColor='#f7f6f5'
          noCloseButton={false}
          backDrop={true}
          bodyPadding='16px'
          id='table-product'
        >
          <PreToPostSubsPopup
            onClose={handleP2PClick}
            content={mainContent?.productContainer?.[0]?.p2pBloks?.[1]}
            prepaid={true}
          />
        </GenericModal>
      )}

      {/* p2p flow after successfully logged in prepaid customer to select a number for P2P*/}
      {userSubscriptionData?.length > 1 &&
        enableP2P &&
        afterLogin &&
        !subscriptionFailure &&
        p2pModal && (
          <GenericModal
            modalState={p2pModal}
            handler={handlePrepaidClick}
            showFooter={false}
            width={'628px'}
            height='280px'
            backgroundColor='#f7f6f5'
            noCloseButton={false}
            backDrop={true}
            bodyPadding='16px'
          >
            <ExsistingSubscriptionModal
              onSubmit={onSelectSubscriptionPreToPost}
              exsistingSubscriptionData={userSubscriptionData}
              updatedContent={updatedContent}
            />
          </GenericModal>
        )}

      {/* lincheck modal  */}
      {showLinecheck &&
      mainContent?.enableLinecheckOverlay &&
      !isMobileFlow &&
      mainContent?.linecheckData?.length > 0 &&
      !enableP2P &&
      mainContent?.linecheckData?.[0]?.reference?.default_full_slug ===
        'global/new-linecheck-test' ? (
        <LinecheckModal
          content={mainContent?.linecheckData?.[0]}
          onSuccess={linecheckSuccessAndCart}
          showModal={showLinecheck}
          setShowModal={setShowLinecheck}
          productName={productData?.productName}
          productId={productData?.productId}
        />
      ) : showLinecheck &&
        mainContent?.enableLinecheckOverlay &&
        !isMobileFlow &&
        mainContent?.linecheckData?.length > 0 &&
        !enableP2P &&
        mainContent?.linecheckData?.[0]?.reference?.default_full_slug ===
          'global/coverage-check' ? (
        <CoverageCheckModal
          content={mainContent?.linecheckData?.[0].reference.content.body[0]}
          overlayIsOpen={true}
          externalHandleModal={setShowLinecheck}
          productName={productData?.productName}
          showModal={showLinecheck}
          setShowModal={setShowLinecheck}
          onSuccess={linecheckSuccess}
          onCreateCart={linecheckSuccessAndCart}
          lineCheckOnClear={lineCheckOnClear}
          productId={productData?.productId}
        />
      ) : null}
      {/* benefit validate  */}
      {showBenefit && isMobileFlow && storyContent?.benefitsValidate?.length > 0 && (
        <BenefitsValidateWrapper
          content={storyContent?.benefitsValidate?.[0]}
          loginContent={mainContent?.loginData?.[0]}
          metadata={metadata}
          createCartCall={createCartCall}
          fetchOfferData={fetchOfferData}
          basicConfigUrl={basicConfigUrl}
          selectedExistingOption={selectedExistingOption}
          setShowBenefit={setShowBenefit}
          setLoginSuccess={setLoginSuccess}
          isProdEnv={isProdEnv}
        />
      )}

      {/* Display tv options on pop up after clicking order now button*/}
      {displayTvOptionsPopUp && (
        <GenericModal
          modalState={displayTvOptionsPopUp}
          handler={closeTVOptionsModal}
          showFooter={false}
          width={viewPortType === 'mobile' ? '' : viewPortType === 'tablet' ? '700px' : '990px'}
          fixedWidth={
            viewPortType === 'mobile' ? '' : viewPortType === 'tablet' ? '700px' : '990px'
          }
          height='845px'
          backgroundColor='#f7f6f5'
          noCloseButton={false}
          backDrop={true}
          bodyPadding='24px'
        >
          <OttServiceOptionsSmallPopup
            content={mainContent?.optionsPopup?.[0]}
            addOptionsCallBack={(val: any) => {
              setTvOptionsPopUpAddToCart(true);
              setTvOptionsPopUpChanged(true);
              setTvOptionsData(val);
            }}
            metadata={metadata}
            constants={constants}
            mainContent={mainContent}
            preSelectedOptions={[]}
            optionsResponse={responseList}
            updateResponseList={setResponseList}
            showPrice={showPrice}
            productData={productData}
            offeringData={offeringData}
            uniqueId={uniqueId}
            deviceFlow={deviceFlow}
          />
        </GenericModal>
      )}

      {/* Replace persistent cart confirmation modal */}
      {showReplaceCartModal && replacePopupContent && (
        <GenericPopup
          modalState={showReplaceCartModal}
          onCloseHandler={() => {
            pendingCartActionRef.current = null;
            setShowReplaceCartModal(false);
          }}
          content={replacePopupContent}
          wafIdentifier={basicConfigUrl}
          onPrimaryClick={() => {
            const pendingAction = pendingCartActionRef.current;
            pendingCartActionRef.current = null;
            if (shouldDeleteCartCookieRef.current) {
              Cookies.remove('one-commerce-cartId');
            }
            shouldDeleteCartCookieRef.current = false;
            setShowReplaceCartModal(false);
            pendingAction?.();
          }}
          onSecondaryClick={() => {
            pendingCartActionRef.current = null;
            setShowReplaceCartModal(false);
          }}
        />
      )}
    </div>
  );
};

export default StaticProduct;
